import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { buildInfo } from 'src/environments/build-info';

/** Cuts the source revision after '+' to the 7-character short hash: '1.0.3+e950792.e9507927e0...' becomes '1.0.3+e950792'. */
export function shortVersion(version: string): string {
    return version.replace(/\+([0-9a-f]{7})[0-9a-f.]*$/i, '+$1');
}

/** Versions of the running portal: the SPA build (baked in at build time) and the API (from its anonymous health endpoint). */
@Injectable({ providedIn: 'root' })
export class VersionService {
    readonly spaVersion = buildInfo.version;

    /** API build version, or null when the health endpoint is unreachable or reports none. */
    readonly apiVersion$: Observable<string | null> = this.http
        .get<{ version?: string }>(`${environment.apiUrl}/health`)
        .pipe(
            map(res => (res.version ? shortVersion(res.version) : null)),
            catchError(() => of(null)),
            shareReplay(1),
        );

    constructor(private http: HttpClient) { }
}
